function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 244 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 244,
    height: 114,
    style: {
      fill: "#d81939"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "m33.01,33.52c-.41.07-.73.15-1,.24v5.27c.79.26,1.74.44,3.06.44,2.66,0,3.06-1.42,3.06-3.06s-.41-3.06-3.06-3.06c-.87,0-1.52.09-2.06.18m-3.74-6.23h2.74v4.81c1.08-.33,1.98-.49,3.06-.49,4.58,0,5.88,1.91,5.88,4.79s-1.3,4.79-5.88,4.79c-1.3,0-2.49-.29-3.71-.75l-.27.51h-1.82v-13.67Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "m49.27,36.69c-1.71.11-2.2.75-2.2,1.38s.22,1.39,2.2,1.39c1.14,0,2.36-.27,3.09-.57v-2.39l-3.09.18Zm.6-3.35c-1.6,0-3.66.29-4.64.55v-1.73c1.06-.33,3.36-.55,4.64-.55,4.18,0,5.26,1.28,5.26,3.17v6.18h-1.87l-.24-.47c-1.11.46-2.6.71-3.79.71-3.77,0-4.93-1.53-4.93-3.12,0-1.44,1-2.71,5.01-2.93l3.06-.16v-.18c0-.98-.54-1.46-2.49-1.46",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "m67.27,34.5c0-.86-.95-1.17-2.2-1.17-1.36,0-2.41.2-3.14.44v7.18h-2.79v-9.11h1.87l.27.51c1.11-.49,2.49-.75,3.79-.75,3.34,0,4.99,1.09,4.99,2.93v6.41h-2.79v-6.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "m85.44,31.84l-5.94,3.83,6.48,5.28h-3.8l-4.53-4.1-.98.64v3.46h-2.74v-13.67h2.74v7.98l4.74-3.43h4.01Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "l",
    d: "m193.27,47.95l-.85-.24c-10.98,5.03-21.72,7.34-25.9,6.83-2.86-.34-3.82-3.21-1.33-6.77v-1.98c-6.04,5.34-7.1,10.27-2.34,11.24,5.88,1.2,18.05-2.71,30.42-9.08",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "m202.21,29.17v1c3.85-.22,6.23.61,6.35,2.62.14,2.44-3.11,6.06-8.34,9.78-.22.16-.45.31-.67.47l.96.26c7.07-4.39,11.66-8.86,11.49-11.74-.15-2.54-3.9-3.28-9.78-2.39",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "m134.18,35.65c-.2.69-.26.84-.26,1.05,0-.2-.03-.35-.23-1.05l-1.21-3.81h-3.78l-1.22,3.81c-.2.69-.24.84-.24,1.05,0-.2-.06-.35-.26-1.05l-1.21-3.81h-3.82l3.45,9.12h3.58l1.29-4.01c.24-.61.27-.69.3-.91.04.22.06.3.31.94l1.28,3.98h3.58l3.47-9.12h-3.84l-1.21,3.81Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "r",
    d: "m118.32,32.88v-1.05h-3.49v9.13h3.49v-5.08c.67-.46,1.38-.61,2.46-.61v-3.56c-.43,0-1.07.12-1.28.22-.58.27-.97.63-1.18.95",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "m108.98,36.69c-.09.64-.46,1.35-1.14,1.72-.61.32-1.51.3-2.13-.14-.57-.4-.88-1.1-.92-1.77-.03-.62.1-1.42.75-2.04.31-.27.58-.39.84-.46.54-.14,1.42.02,1.98.63.51.57.71,1.44.63,2.06m-2.97-5.17c-.75.1-1.68.34-2.43.76-1.46.79-2.19,2.04-2.37,3.53-.14,1.2.1,2.65,1.14,3.73,1.82,1.89,5.04,1.93,6.86,1.34,1.51-.52,2.76-1.37,3.3-3.31.34-1.27.2-2.6-.64-3.82-1.51-2.23-4.59-2.4-5.85-2.23",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    id: "v",
    d: "m175.23,37.45c.24-.51.73-.46,1.82-.47l1.88-.03c-.33,1.17-.98,1.56-1.89,1.71-.5.08-1.32.14-1.73-.54-.07-.12-.16-.51-.07-.66m-2.2,3.25l.1.09c1.73.73,3.98.47,5.93-.66,0,0,0,.56.14.83l4.01-.02c-.43-.41-.61-1.03-.61-1.9v-3.89c0-.76.07-1.73-.43-2.36-.83-1.1-2.32-1.32-4.99-1.32-2.13,0-3.61.1-4.42,1.22-.39.54-.5.98-.52,1.73h3.12c.06-.22.17-.4.36-.54.45-.36,2.12-.27,2.57-.03.51.25.61.64.67,1.26,0,0-1.09-.07-1.8-.03-.85.05-1.24.08-2,.2-1.52.2-3.04.47-3.42,2.28-.27,1.25.1,2.42,1.29,3.15",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    id: "x",
    d: "m97.81,32.09c-1.42-.86-3.63-.84-5.32.66v-.91h-3.49v9.12h3.49v-3.67c0-1.3-.1-2.02.78-2.68.5-.37,1.36-.37,1.79-.1.88.58.81,1.72.81,2.58v3.87h3.47v-4.85c0-1.6,0-3.09-1.53-4.02",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "z",
    d: "m188.54,37.29c0-1.3-.1-2.02.78-2.68.5-.37,1.36-.37,1.79-.1.88.58.81,1.72.81,2.58v3.87h3.47v-4.85c0-1.6,0-3.09-1.53-4.02-1.42-.86-3.63-.84-5.32.66v-.91h-3.49v9.12h3.49v-3.67Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ab",
    d: "m159.39,37.34c-.59.39-1.56.36-2.15.03-.43-.24-.74-.56-.81-1.07-.06-.34.03-.88.34-1.25.23-.29.49-.44.86-.56.45-.12,1.46-.03,1.95.51.34.34.49.73.46,1.18-.04.41-.26.9-.64,1.15m4.09-5.51h-3.47v.81c-.77-.74-1.59-1-2.18-1.08-1.29-.22-3.02.25-4.11,1.64-.89,1.12-1.04,2.77-.85,3.89.21,1.39.94,2.4,2.23,3.11,1.4.74,3.64.58,4.91-.49,0,.37,0,1.22-.13,1.57-.24.54-.73.74-1.16.79-.36.03-1.41.24-1.76-.44-.06-.11-.1-.19-.13-.3h-3.61c.05.7.24,1.15.34,1.33.89,1.57,2.45,1.91,4.42,1.91s3.5-.12,4.62-1.43c.99-1.18.89-2.65.89-4.04v-7.27Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "ac",
    d: "m166.11,30.75h3.49v-2.32h-3.49v2.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad",
    d: "m166.11,40.96h3.49v-9.11h-3.49v9.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    id: "af",
    d: "m143.7,35.24c.29-1,.87-1.34,1.56-1.46.75-.14,2.02.08,2.56,1.46h-4.12Zm-.1-3.5c-1.53.46-2.8,1.31-3.33,3.28-.4,1.46-.23,2.82.63,4.07,1.62,2.35,4.8,2.23,6.31,1.99,1.11-.19,3.23-.79,3.96-2.84l.04-.08-3.45-.39c-.11.15-.17.27-.55.54-.6.42-1.83.36-2.34.17-.58-.24-1.07-.93-1.11-1.4h7.73v-.17c-.02-1.12-.37-2.64-1.27-3.68-1.65-1.92-5.03-1.98-6.62-1.49",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m29.27,65.75c0-.28.22-.5.5-.5h182c.28,0,.5.22.5.5s-.22.5-.5.5H29.77c-.28,0-.5-.22-.5-.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.32,85.76h-1.01l-.22-1.09c-.49.71-1.27,1.21-2.43,1.21-1.29,0-2.4-.69-2.4-2.35s1.38-2.54,3.5-2.54h1.26v-.34c0-1.2-.75-1.6-1.69-1.6-.8,0-1.44.45-1.61,1.21l-1.14-.26c.21-1.31,1.29-2.12,2.75-2.12,1.71,0,2.98.86,2.98,2.92v4.95Zm-3.46-1.04c1,0,2.17-.61,2.17-2.37v-.18h-1.38c-1.32,0-2.06.49-2.06,1.37,0,.74.46,1.18,1.28,1.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.83,85.88c-.98,0-2-.6-2.26-1.04v4.06h-1.29v-10.88h1.29v.95c.37-.57,1.32-1.08,2.26-1.08,2.27,0,3.44,1.67,3.44,3.99s-1.17,3.99-3.44,3.99Zm-.12-6.82c-1.41,0-2.24,1.17-2.24,2.83s.83,2.83,2.24,2.83,2.24-1.17,2.24-2.83-.88-2.83-2.24-2.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.76,85.76h-1.01l-.22-1.09c-.49.71-1.27,1.21-2.43,1.21-1.29,0-2.4-.69-2.4-2.35s1.38-2.54,3.5-2.54h1.26v-.34c0-1.2-.75-1.6-1.69-1.6-.8,0-1.44.45-1.61,1.21l-1.14-.26c.21-1.31,1.29-2.12,2.75-2.12,1.71,0,2.98.86,2.98,2.92v4.95Zm-3.46-1.04c1,0,2.17-.61,2.17-2.37v-.18h-1.38c-1.32,0-2.06.49-2.06,1.37,0,.74.46,1.18,1.28,1.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.99,79.27c-.28-.14-.58-.22-.91-.22-1.06,0-2.17,1.24-2.17,3.76v2.93h-1.29v-7.74h1.29v1.32c.46-.86,1.41-1.44,2.27-1.44.43,0,.83.11,1.06.23l-.26,1.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.87,78.01h1.34v-2.32l1.29-.81v3.13h2.03v1.17h-2.03v4.26c0,.83.38,1.28,1.03,1.28.34,0,.6-.06.88-.25l.31,1.12c-.37.22-.81.29-1.26.29-1.31,0-2.24-.8-2.24-2.55v-4.15h-1.34v-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.34,77.89c2.32,0,3.72,1.89,3.72,3.99s-1.4,3.99-3.72,3.99-3.72-1.89-3.72-3.99,1.4-3.99,3.72-3.99Zm0,6.82c1.58,0,2.4-1.4,2.4-2.83s-.81-2.83-2.4-2.83-2.4,1.4-2.4,2.83.81,2.83,2.4,2.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.09,78.01h1.11v-.51c0-1.78.94-2.63,2.5-2.63.43,0,.86.11,1.11.25l-.26,1.14c-.28-.14-.58-.22-.86-.22-.85,0-1.2.46-1.2,1.46v.51h1.78v1.17h-1.78v6.58h-1.29v-6.58h-1.11v-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.9,75v10.75h-2.1l-3.95-7.1v7.1h-2v-10.75h2.1l3.95,7.1v-7.1h2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.76,80.38c0,3.73-2.35,5.5-5.07,5.5s-5.07-1.77-5.07-5.5,2.35-5.5,5.07-5.5,5.07,1.77,5.07,5.5Zm-8.11,0c0,2.55,1.43,3.66,3.04,3.66s3.04-1.11,3.04-3.66-1.43-3.66-3.04-3.66-3.04,1.11-3.04,3.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.19,75c1.83,0,3.07.95,3.07,2.9,0,.88-.38,1.63-1.06,1.98,1.01.41,1.61,1.26,1.61,2.63,0,2.09-1.35,3.24-3.55,3.24h-4.01v-10.75h3.93Zm-1.94,1.84v2.34h1.83c.8,0,1.26-.29,1.26-1.17s-.46-1.17-1.31-1.17h-1.78Zm0,4.18v2.89h1.83c1.24,0,1.74-.52,1.74-1.44s-.49-1.44-1.74-1.44h-1.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.68,83.22h-3.41l-.78,2.54h-2.15l3.64-10.75h2l3.64,10.75h-2.15l-.78-2.54Zm-2.84-1.84h2.27l-1.14-3.73-1.14,3.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.2,75c1.83,0,3.07.95,3.07,2.9,0,.88-.38,1.63-1.06,1.98,1.01.41,1.61,1.26,1.61,2.63,0,2.09-1.35,3.24-3.55,3.24h-4.01v-10.75h3.93Zm-1.94,1.84v2.34h1.83c.8,0,1.26-.29,1.26-1.17s-.46-1.17-1.31-1.17h-1.78Zm0,4.18v2.89h1.83c1.24,0,1.74-.52,1.74-1.44s-.49-1.44-1.74-1.44h-1.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.04,80.04c.25-1.28,1.37-2.15,2.95-2.15,1.84,0,3.26.77,3.26,3.24v4.62h-1.57l-.2-.98c-.54.66-1.28,1.11-2.38,1.11-1.32,0-2.35-.81-2.35-2.35s1.35-2.54,3.3-2.54h1.29v-.34c0-.86-.65-1.14-1.35-1.14-.54,0-1.09.17-1.34.89l-1.61-.37Zm2.5,4.21c.88,0,1.8-.6,1.8-1.6v-.15h-1.27c-.81,0-1.32.31-1.32,1,0,.37.26.75.8.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.63,78.01v1.24c.57-.81,1.4-1.37,2.4-1.37,1.38,0,2.38.78,2.38,2.34v5.53h-1.91v-4.96c0-.92-.46-1.28-1.11-1.28-.92,0-1.77,1.11-1.77,3.15v3.09h-1.9v-7.74h1.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.96,74.88v6.18l2.52-3.04h2.35l-3.1,3.56,3.3,4.18h-2.34l-2.73-3.66v3.66h-1.9v-10.88h1.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.58,84.61c-.41.63-1.23,1.28-2.61,1.28-2.6,0-4.96-1.83-4.96-5.5s2.46-5.5,5.12-5.5c2.4,0,3.92,1.43,4.47,3.4l-1.83.48c-.51-1.23-1.34-2.03-2.64-2.03-1.72,0-3.09,1.15-3.09,3.66s1.37,3.66,3.04,3.66c1.58,0,2.29-1.08,2.41-2.04h-2v-1.66h3.93v5.42h-1.67l-.17-1.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.29,85.76v-7.74h1.9v1.26c.55-.91,1.41-1.38,2.29-1.38.34,0,.63.06.94.15l-.35,1.77c-.23-.14-.48-.21-.8-.21-1.11,0-2.07.91-2.07,3.41v2.75h-1.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.86,77.89c2.49,0,3.93,1.75,3.93,3.99s-1.44,3.99-3.93,3.99-3.93-1.75-3.93-3.99,1.44-3.99,3.93-3.99Zm0,6.36c1.23,0,1.94-1.09,1.94-2.37s-.71-2.37-1.94-2.37-1.94,1.09-1.94,2.37.71,2.37,1.94,2.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.98,85.76v-1.24c-.57.81-1.4,1.37-2.4,1.37-1.38,0-2.38-.78-2.38-2.33v-5.53h1.9v4.96c0,.92.46,1.28,1.11,1.28.92,0,1.77-1.11,1.77-3.15v-3.09h1.9v7.74h-1.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.47,85.88c-.78,0-1.54-.4-1.87-.83v3.84h-1.9v-10.88h1.9v.8c.22-.4.92-.92,1.87-.92,2.34,0,3.53,1.61,3.53,3.99s-1.2,3.99-3.53,3.99Zm-.26-6.36c-1,0-1.78.83-1.78,2.37s.78,2.37,1.78,2.37,1.8-.83,1.8-2.37-.8-2.37-1.8-2.37Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBn);
export default __webpack_public_path__ + "static/media/BN.8b4efd9ed7bee6875ca7aac03600d369.svg";
export { ForwardRef as ReactComponent };